module.exports = __webpack_public_path__ + "static/maiaabout-da094014e5acf32f551491b5bc9b22b4.png";